import React, { useEffect, useRef, useState } from 'react';
import styles from './style.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComments, faLink, faPlus, faAddressCard, faChevronRight, faExclamation, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../constant';
import { addJobComment, deleteJobComment, jobComment, postedOppurtunitiesList } from '../../action/jobs';
import { toast } from 'react-toastify';
import moment from 'moment';
import Item from 'antd/lib/list/Item';
import { getStorage, removeSessionStorage, removeStorage, setsessionStorage, ToSeoUrl } from '../../utils';

const JobPagination = ({ setPage, setJobs, setHasMore, fetchJobs, hasMore, jobs, isLoading, page, filter, setFilter, changeStatus, filterCount }) => {
    const bottomRef = useRef(null);

    const [isOpen, setIsOpen] = useState(false);
    const [addClass, setAddClass] = useState(false);
    const history = useHistory()
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };
    // Handle filter change
    const onFilterChange = (newFilter) => {
        setFilter(newFilter);
        setPage(1);
        setJobs(null);
        setHasMore(true);
        fetchJobs(1, newFilter);
    };

    // Load more jobs when scrolling or manually triggered
    const loadMoreJobs = () => {
        if (hasMore && !isLoading) {
            fetchJobs(page + 1, filter);
        }
    };
    const getJobTypeLabel = (type) => {
        switch (Number(type)) {
            case 1:
                return 'REGULAR JOB';
            case 2:
                return 'FEATURED JOBS';
            case 3:
                return 'PREMIUM JOBS';
            default:
                return 'UNKNOWN JOB TYPE';
        }
    };
    const [openedCommentBoxJobId, setOpenedCommentBoxJobId] = useState(null);
    const [showCommentBox, setShowCommentBox] = useState(false);
    const [comment, setComment] = useState({ value: "" });
    const [fetchedComment, setFetchedComment] = useState({});

    const onFetchComment = (jobId) => {
        jobComment(jobId).then((res) => {
            if (res.status) {
                setFetchedComment((prevComments) => ({
                    ...prevComments,
                    [jobId]: res.result,
                }));
            }
        });
    };

    const handleCommentsClick = (jobId) => {
        onFetchComment(jobId)

        if (openedCommentBoxJobId === jobId) {
            setOpenedCommentBoxJobId(null);
            setShowCommentBox(false);
        } else {
            setOpenedCommentBoxJobId(jobId);
            setShowCommentBox(true);
        }
    };

    const handleCommentChange = (e) => {
        setComment({ ...comment, value: e.target.value });
    };


    const handleAddComment = (data) => {
        const ud = JSON.parse(atob(getStorage(constant.keys.userDetails)));
        if (comment.value.length > 0) {
            addJobComment({
                JOB_ID: data.JOB_ID,
                EMAIL: ud.EMAIL,
                COMMENT: comment.value,
            }).then((res) => {
                if (res.status) {
                    setComment({ value: "" });
                    onFetchComment(data.JOB_ID)
                } else {
                    toast.error(res.error)
                }
            });
        }
    };
    const removeComment = (commentId) => {
        deleteJobComment(commentId).then((res) => {
            if (res.status) {
                onFetchComment(openedCommentBoxJobId)
            } else {
                toast.error(res.error)
            }
        });
    }

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && hasMore && !isLoading) {
                    loadMoreJobs();
                }
            },
            { threshold: 1.0 }
        );

        if (bottomRef.current) {
            observer.observe(bottomRef.current);
        }

        return () => observer.disconnect();
    }, [hasMore, isLoading, loadMoreJobs]);

    return (
        <div className='row'>
            <div className='col-md-12'>
                <div className={`${styles['filter-box']}`}>
                    <ul className={`${styles['filter-list']}`}>
                        <li><a className={`${filter === 'ALL' ? styles['list-active'] : ''}`} href='javascript:void(0);' onClick={() => {
                            onFilterChange('ALL')
                        }}>All<span>({filterCount?.allCount})</span></a></li>
                        <li><a className={`${filter === 'OPEN' ? styles['list-active'] : ''}`} href='javascript:void(0);' onClick={() => {
                            onFilterChange('OPEN')
                        }}>Live<span>({filterCount?.liveCount})</span></a></li>
                        <li><a className={`${filter === 'INCOMPLETE' ? styles['list-active'] : ''}`} href='javascript:void(0);' onClick={() => {
                            onFilterChange('INCOMPLETE')
                        }}>Incomplete<span>({filterCount?.inCompleteCount})</span></a></li>
                        <li><a className={`${filter === 'ON HOLD' ? styles['list-active'] : ''}`} href='javascript:void(0);' onClick={() => {
                            onFilterChange('ON HOLD')
                        }}>On Hold <span>({filterCount?.inactiveCount})</span></a></li>
                        <li><a className={`${filter === 'CLOSE' ? styles['list-active'] : ''}`} href='javascript:void(0);' onClick={() => {
                            onFilterChange('CLOSE')
                        }}>Closed <span>({filterCount?.expiredCount})</span></a></li>
                    </ul>
                    <select className={`${styles['filter-select']} rounded-pill form-select`} aria-label="Default select example">
                        <option selected>Filter by Opportunity type</option>
                        <option value="job">Job</option>
                        <option value="internship">Internship</option>
                    </select>
                </div>
            </div>
            <div className='col-md-12'>
                <div className={`${styles['job-lists']}`}>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h3 className={`${styles['intern-heading']}`}>All Jobs and Internships</h3>
                                <div className='position-relative'>
                                    <button className={`${styles['book-btn']} btn`} onClick={toggleDropdown}><span className={`${styles['dd-view']}`}>Post a New Oppurtunity</span><span className={`${styles['mm-view']}`}><FontAwesomeIcon icon={faPlus} /></span></button>
                                    <div className={`dropdown-menu ${styles['ctmdropdown-menu']} ${isOpen ? "show" : ""}`}>
                                        <div className={`${styles['ctmdropdown-option']} ${styles['ctmdropdown-optionhover']}`} onClick={() => {
                                            removeSessionStorage(constant.keys.jobPostingSession)
                                            window.open(constant.component.postOppurtunity.url, '_self');
                                        }}
                                        >
                                            <span className={`${styles['icon-address']}`}><FontAwesomeIcon icon={faAddressCard} /></span>
                                            <div className={`${styles['details-ctm']}`}>
                                                <h4>Start with new post</h4>
                                                <h5>Fill the form and Create Job Post</h5>
                                            </div>
                                            <div className='d-flex'>
                                                <FontAwesomeIcon className={`${styles['arrow-right']}`} icon={faChevronRight} />
                                            </div>
                                        </div>
                                        <hr />
                                        <div className={`${styles['ctmdropdown-option']} ${styles['ctmdropdown-optiontwhover']}`}>
                                            <span className={`${styles['icon-address']} text-warning`}><FontAwesomeIcon icon={faAddressCard} /></span>
                                            <div className={`${styles['details-ctm']} w-85`}>
                                                <h4 className={`${styles['ctm-yellow']}`}>Post with Previously Posted Requirement</h4>
                                                <h5>(AI-Powered Job Description Generator)</h5>
                                                <span>Save 80% more time</span>
                                            </div>
                                            <div className='d-flex'>
                                                <FontAwesomeIcon icon={faChevronRight} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={`${styles['all-lists']} ${addClass ? "new-class" : ""}`}>
                                {jobs.map((item) => {
                                    return (
                                        <div className="card mb-3">
                                            <div className="card-body">
                                                <div className='row'>
                                                    <div className='col-md-12'
                                                        style={item.STATUS === 'U' && item.STATUS_BY_EMPLOYER === 'OPEN' && item.ACTION_FROM_ADMIN === 'APPROVED' ? { cursor: 'pointer' } : {}}
                                                        onClick={() => {
                                                            if (
                                                                item.STATUS === 'U' &&
                                                                item.STATUS_BY_EMPLOYER === 'OPEN' &&
                                                                item.ACTION_FROM_ADMIN === 'APPROVED'
                                                            ) {
                                                                history.push(constant.component.OppurtunityApplications.url.replace(':job_id', item.JOB_ID));
                                                            } else {
                                                                setsessionStorage(constant.keys.jobPostingSession, {
                                                                    step: !item.JOB_DETAILS ? 2 : !item.IS_INCLUDE_WALK_IN ? 3 : 5,
                                                                    id: item.JOB_ID
                                                                });
                                                                // window.open(constant.component.postOppurtunity.url, '_blank');

                                                                history.push(constant.component.postOppurtunity.url);
                                                            }
                                                        }}


                                                    >
                                                        <h5 className={`${styles['card-titletext']}`}>
                                                            {/* Campus Exclusive Badge */}
                                                            {item.OPPURTUNITY_TYPE === 'CAMPUS_EXCLUSIVE' && (
                                                                <div className={styles['campus-exclusive-corner']}>
                                                                    🎓 Campus Exclusive
                                                                </div>
                                                            )}
                                                            {item.JOB_TITLE}
                                                            {/* {item.OPPURTUNITY_TYPE === 'CAMPUS_EXCLUSIVE' && (
                                                                <span className={`${styles['badge-list']} ${styles['campus-exclusive']}`}>
                                                                    🎓 Campus Exclusive
                                                                </span>
                                                            )} */}
                                                            {item.LISTNING_TYPE ? (
                                                                <span className={`${styles['badge-list']} ${styles[Number(item.LISTNING_TYPE) === 1 ? 'regular' : Number(item.LISTNING_TYPE) === 2 ? 'featured' : 'premium']}`}>
                                                                    {getJobTypeLabel(item.LISTNING_TYPE)}
                                                                </span>
                                                            ) : <Link className={`${styles['badge-list']} ${styles['select-package']}`}
                                                                to={
                                                                    constant.component.postOppurtunity.url
                                                                }
                                                                onClick={() => {
                                                                    setsessionStorage(constant.keys.jobPostingSession, { step: !item.JOB_DETAILS ? 2 : !item.IS_INCLUDE_WALK_IN ? 3 : 5, id: item.JOB_ID })
                                                                }}
                                                            >
                                                                {!item.JOB_DETAILS ? 'Complete Candidate Detail' : !item.IS_INCLUDE_WALK_IN ? 'Complete Interview Detail' : 'Select Package'}
                                                            </Link>}

                                                        </h5>
                                                    </div>
                                                    <div className='col-md-12'>
                                                        <div className='row'>
                                                            <div className='col-sm-7'>
                                                                <p className={`${styles['card-text']}`}>{item.city.join(', ')}, {moment(item.MODIFIED_ON).format('DD/MM/YYYY')}, {item.postedByName}</p>
                                                            </div>
                                                            <div className='col-sm-5'>
                                                                <div className='d-flex justify-content-between margin-t5'>
                                                                    <div className={`${styles['application-status']}`}>{item.applyCount != 0 ? item.applyCount + ' Applications Received' : 'No Application Received'}</div>
                                                                    <a href='javascript:void(0);' onClick={() => {
                                                                        handleCommentsClick(item.JOB_ID);
                                                                    }}><FontAwesomeIcon className={`${styles['icon-list']}`} icon={faComments} /></a>
                                                                    <a href="javascript:void(0);"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            navigator.clipboard.writeText(`https://jobzshala.com/job/${ToSeoUrl(item.JOB_TITLE)}-${item.JOB_ID}`).then(() => {
                                                                                toast.success('Link copied to clipboard!');
                                                                            }).catch(err => {
                                                                                console.error('Failed to copy link:', err);
                                                                            });
                                                                        }}><FontAwesomeIcon className={`${styles['icon-list']}`} icon={faLink} /></a>
                                                                    {item.STATUS === 'A' ? <button
                                                                        className={`${styles['select-list']} ${styles['non-posted']}`}
                                                                    >
                                                                        Not Posted

                                                                    </button> :

                                                                        <select className={`${styles['select-list']} form-select ${styles[item.STATUS_BY_EMPLOYER === 'ON_HOLD' ? 'expired' : item.STATUS_BY_EMPLOYER === 'OPEN' ? 'opened' : item.STATUS_BY_EMPLOYER === 'CLOSE' ? 'close' : 'expired']}`}
                                                                            value={item.STATUS_BY_EMPLOYER}
                                                                            onChange={(e) => {
                                                                                changeStatus(item.JOB_ID, e.target.value)
                                                                            }}
                                                                        // disabled={item.STATUS_BY_EMPLOYER === 'A'}

                                                                        >
                                                                            {/* <option value="" disabled>Select Status</option> */}
                                                                            <option value="OPEN">Opened</option>
                                                                            <option value="CLOSE">Closed</option>
                                                                            <option value="ON HOLD">On Hold</option>
                                                                        </select>}
                                                                </div>
                                                            </div>

                                                        </div>
                                                        {item.STATUS === 'A' && <div class="alert alert-dark alert-height-small mt-2" role="alert">
                                                            <FontAwesomeIcon icon={faExclamationCircle} />  Finish job posting to start receiving candidates
                                                        </div>}
                                                    </div>
                                                    {openedCommentBoxJobId &&
                                                        showCommentBox &&
                                                        openedCommentBoxJobId === item.JOB_ID && (
                                                            <table className='ms-2 w-50'>
                                                                <tr>
                                                                    <td style={{ width: "100%" }}>
                                                                        <div className="text-right" style={{ width: "100%" }}>
                                                                            <textarea
                                                                                className="form-control w-100"
                                                                                name="comment"
                                                                                value={comment.value}
                                                                                onChange={handleCommentChange}

                                                                            ></textarea>
                                                                            <button
                                                                                className="btn my-2 btn-comment btn-sm"
                                                                                onClick={() => { handleAddComment(item) }}
                                                                            >
                                                                                Add Comment
                                                                            </button>
                                                                        </div>
                                                                        <div>
                                                                            {fetchedComment[item.JOB_ID]?.length > 0 &&
                                                                                fetchedComment[item.JOB_ID].map((commentDetail) => (
                                                                                    <div
                                                                                        className='d-flex'
                                                                                        key={commentDetail.COMMENT_ID}
                                                                                    >
                                                                                        <span className=''>
                                                                                            {commentDetail.EMAIL}{" "}
                                                                                            <a
                                                                                                onClick={() =>
                                                                                                    removeComment(commentDetail.COMMENT_ID)
                                                                                                }
                                                                                            >
                                                                                                <i className="fa text-danger fa-trash"></i>
                                                                                            </a>
                                                                                        </span>
                                                                                        <span className="commenttextn px-3">
                                                                                            {commentDetail.COMMENT}
                                                                                        </span>
                                                                                        <span className="commentDaten">
                                                                                            {moment(commentDetail.MODIFIED_ON).format(
                                                                                                "DD-MMM-YYYY  hh:mm:ss"
                                                                                            )}
                                                                                        </span>
                                                                                    </div>
                                                                                ))}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        )}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                                {/* {hasMore && (
                                    <React.Fragment>
                                        <div className="card mb-3" onClick={loadMoreJobs} disabled={isLoading}>
                                            <div className="card-body">
                                                <div className='row'>
                                                    <div className='col-md-12'>
                                                        <div className='row text-center'>
                                                            {isLoading ? "Loading..." : "Load More Jobs"}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                )} */}
                                {hasMore && <div ref={bottomRef} style={{ height: 50, background: "transparent" }} />}

                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    );
};

export default JobPagination;